
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';
import LunchScreen from './lunch';

function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [ribeye, setRibeye] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [appetizers, setAppetizers] = useState(false);
    const [showListProduct2, setShowListProduct2] = useState(false);
    const [datadishs, setdishs] = useState(false);
    const [showLunch, setShowLunch] = useState(false);

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    
   useEffect(() => {
            menus.map((item) => {
                
                if (item.id === 215) {
                    setAppetizers(item);
                }
               
            });
      }, [menus]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 2811) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }
            });
        }
    }, [dataFood]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} goHome={setShowHappy} goCategories={setshowCategories}>
                <div style={{ padding: '0 20px' }}>
                    
                    <div
            onClick={() =>
                        {
                            setdishs(appetizers)
                               setShowListProduct2(true)
              }
            }
            style={{
              backgroundColor: '#3D0047',
              width: '85%',
              padding: 5,
              borderRadius: 10,
              marginTop: 5,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
                alignSelf: 'center',
                display: 'flex',
              margin: '0 auto'
            }}>
            <img
              style={{
                width: 60,
                height: 60,
                objectFit: 'contain',
                marginLeft: 10,
              }}
              src={require('./assets/leftspecials.png')}
            />
            <div style={{width: '70%'}}>
              <p
                style={{
                  fontWeight: 'bold',
                  color: '#fff',
                  fontSize: 30,
                  textAlign: 'center',
                }}>
                {langEng ? 'TRY OUR NEW APPETIZER' : 'TRY OUR NEW APPETIZER'}
              </p>
            </div>
            <img
              style={{
                width: 60,
                height: 60,
                objectFit: 'contain',
                marginLeft: 10,
              }}
              src={require('./assets/rightspecials.png')}
            />
                    </div>

                    
                    <img
                        src={require('./assets/DFNJSFGJKS.png')}
                        style={{
                        marginTop: 20,
                        width: '100%',
                        height: 205,
                       objectFit: 'contain',
                        borderRadius: 10,
                        }}
                    />

                    
                    <div>
                        <img
                        src={require('./assets/sdfjfg.png')}
                        style={{
                            marginTop: 10,
                            width: '100%',
                             height: 205,
                            objectFit: 'contain',
                        }}
                        />
                    </div>

                    <div
                     onClick={()=> setShowLunch(true)}
                    >
                        <img
                        src={require('./assets/lunch.png')}
                        style={{
                            marginTop: 10,
                            width: '100%',
                            height: 205,
                            objectFit: 'contain',
                        }}
                        />
                    </div>
                    

                    {/* <div
                        onClick={() => {
                            setShowDetailProduct(true);
                            setDataDish({ dish: grill, alldish: dataFood, currentDish: grill })
                        }}>
                        <img
                            src={require('./assets/banner1.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 770,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div> */}

                </div>

                {showListProduct2 && <ListProducts
                dishs={datadishs}
                setShowListProduct={setShowListProduct2}
            />}

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}

                 {showLunch && <LunchScreen setshowCategories={setShowLunch} />}

                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
            </LayoutContent>
        </div>
    );
}
export default Index;